/**
 * @fileoverview Based on https://www.figma.com/file/ORa7CBIooPgZj6HsEPBxNR/Design-bibliotheek-(gepubliceerd)?node-id=1303%3A6122
 * The values for Desktop klein are used
 */
export { getSelectStyle } from '../Select/SelectStyles';
